var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"display":"inline-block","width":"100%"},on:{"mouseover":_vm.hover,"mouseleave":_vm.leave}},[_c('svg-icon',{attrs:{"icon-class":_vm.on+_vm.iconClass}}),_vm._v(" "+_vm._s(_vm.title)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }